<script>
  import { createEventDispatcher, getContext, onDestroy } from "svelte";
  import { createRandomEncoding } from "bitframes";

  export let encoding;
  export let decoded;

  const dispatch = createEventDispatcher();

  const preview = getContext("encoding-preview");

  let curPreview;
  let value = encoding[1]; //curPreview ? curPreview[1] : encoding[1];
  // $: {
  //   value = curPreview ? curPreview[1] : encoding[1];
  // }

  const unsubPreview = preview.subscribe((v) => {
    curPreview = v;
  });

  onDestroy(() => {
    unsubPreview();
  });

  function getNewEncoding() {
    const newEncoding = encoding.slice();
    const n = value | 0;
    newEncoding[1] = Math.max(0, Math.min(255, n));
    return newEncoding;
  }
</script>

<div class="container">
  <input
    type="range"
    min={0}
    max={255}
    step={1}
    bind:value
    on:input={(ev) => {
      console.log(ev.target.value);
      const oldEncoding = encoding;
      const newEncoding = getNewEncoding();
      if (oldEncoding[1] !== newEncoding[1]) preview.update(() => newEncoding);
    }}
    on:change={(ev) => {
      console.log(ev.target.value);
      const oldEncoding = encoding;
      const newEncoding = getNewEncoding();
      // preview.update(() => null);
      if (oldEncoding[1] !== newEncoding[1])
        dispatch("encodingChanged", newEncoding);
    }}
  />
  <div class="label">{String(value).padStart(3, "0")}</div>
</div>

<style>
  .container {
    display: flex;
    gap: 10px;
    align-items: center;
    width: 100%;

    --thumb-width: 10px;
    --thumb-height: 20px;

    --track-height: 2px;
    --track-padding: 0;
    --track-background: black;
    --thumb-background: white;
    --thumb-border: 1px solid black;
    --thumb-box-shadow: 0px 1px 0px black, 1px 0px 0px black, 1px 1px 0px black;
  }
  input[type="range"] {
    /* appearance: none; */
    width: 100%;
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
    padding: 10px 0px;
    /* background: pink; */
  }

  input[type="range"]::-webkit-slider-runnable-track {
    background: var(--track-background);
    height: var(--track-height);
    padding: var(--track-padding);
    box-sizing: border-box;
  }

  /******** Firefox ********/
  input[type="range"]::-moz-range-track {
    background: var(--track-background);
    height: var(--track-height);
    padding: var(--track-padding);
    box-sizing: border-box;
  }

  /***** Thumb Styles *****/
  /***** Chrome, Safari, Opera, and Edge Chromium *****/
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    margin-top: calc((var(--track-height) - var(--thumb-height)) * 0.5);
    background-color: var(--thumb-background);
    border: var(--thumb-border);
    box-shadow: var(--thumb-box-shadow);
    height: var(--thumb-height);
    width: var(--thumb-width);
  }

  /***** Thumb Styles *****/
  /***** Firefox *****/
  input[type="range"]::-moz-range-thumb {
    border: none; /*Removes extra border that FF applies*/
    border-radius: 0; /*Removes default border-radius that FF applies*/
    background-color: var(--thumb-background);
    border: var(--thumb-border);
    box-shadow: var(--thumb-box-shadow);
    height: var(--thumb-height);
    width: var(--thumb-width);
  }

  /***** Focus Styles *****/
  /* Removes default focus */
  input[type="range"]:focus {
    outline: none;
  }

  /***** Chrome, Safari, Opera, and Edge Chromium *****/
  input[type="range"]:focus::-webkit-slider-thumb {
    /* border: none; */
    outline: none;
    outline-offset: 0;
  }

  /******** Firefox ********/
  input[type="range"]:focus::-moz-range-thumb {
    /* border: none; */
    outline: none;
    outline-offset: 0;
  }
</style>
